import { createContext } from 'react';
import type { CursorMarkerOver } from './implementations/CursorMarker';

export type MarkerCanvasContext = {
  subscribeToMouseOver: (fn: (args: CursorMarkerOver) => void) => () => void;
};

const defaultContextState: MarkerCanvasContext = {
  subscribeToMouseOver: () => {
    console.warn('"subscribeToMouseOver" default func is being used');
    return () => {};
  },
};

const { Consumer, Provider } =
  createContext<MarkerCanvasContext>(defaultContextState);

export const MarkerCanvasProvider = Provider;
export const MarkerCanvasConsumer = Consumer;
